/**
 * View Transitions — Clean page-to-page transitions.
 *
 * Cancels active transitions on user interaction to preserve INP.
 * The actual transition is CSS-only via @view-transition { navigation: auto }
 * in critical.css. No JS coordination needed for the default cross-fade.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lowPower =
    (navigator.hardwareConcurrency || 4) <= 2 || (navigator.deviceMemory || 4) <= 2;

  if (reducedMotion || lowPower) return;
  if (!document.startViewTransition) return;

  function skipIfActive() {
    if (document.activeViewTransition) document.activeViewTransition.skipTransition();
  }

  document.addEventListener('pointerdown', skipIfActive);
  document.addEventListener('keydown', skipIfActive);
})();
